import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService, authInterceptor } from 'angular-auth-oidc-client';
import { switchMap, take } from 'rxjs/operators';

const oidcAuthenticationInterceptor = authInterceptor();

export const authenticationInterceptor: HttpInterceptorFn = (request, next) => {
  const oidcSecurityService = inject(OidcSecurityService);

  return oidcAuthenticationInterceptor(request, (requestWithAccessToken) => {
	if (!requestWithAccessToken.headers.has('Authorization')) {
	  return next(requestWithAccessToken);
	}

	return oidcSecurityService.getAccessToken().pipe(
	  take(1),
	  switchMap((accessToken) => {
		if (!accessToken) {
		  return next(requestWithAccessToken);
		}

		const requestWithIdToken = requestWithAccessToken.clone({
		  setHeaders: { Authorization: `Bearer ${accessToken}` }
		});

		return next(requestWithIdToken);
	  })
	);
  });
};
